// state.js

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
  page: 0,
  limit: 25,
};


export default initialState;
